import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=522f1b25&scoped=true&"
import script from "./Modal.vue?vue&type=script&lang=ts&"
export * from "./Modal.vue?vue&type=script&lang=ts&"
import style0 from "./Modal.vue?vue&type=style&index=0&id=522f1b25&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522f1b25",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('522f1b25')) {
      api.createRecord('522f1b25', component.options)
    } else {
      api.reload('522f1b25', component.options)
    }
    module.hot.accept("./Modal.vue?vue&type=template&id=522f1b25&scoped=true&", function () {
      api.rerender('522f1b25', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "common/src/components/Modal.vue"
export default component.exports